import React from "react";
import InvoiceList from "../components/invoices/InvoiceList";

export default function Invoices() {
  return (
    <div className="space-y-5" data-testid="page-invoices">
      <div>
        <h1 className="text-3xl font-display font-bold text-primary">Fatturazione</h1>
        <p className="text-sm text-muted-foreground">Fatture attive e passive, incassi/pagamenti collegati alla prima nota, export XML FatturaPA per lo SDI</p>
      </div>
      <InvoiceList />
    </div>
  );
}
